import React, { useMemo } from "react";

export default function FunnelOverview({ data }) {
  const funnelConfig = [
    {
      label: "Lead Received",
      event: "LOGIN_MOBILE",
      color: "#035865",
      width: "100%",
    },
    {
      label: "Form Completed",
      event: "LOAN_FORM_COMPLETED",
      color: "#F0B96C",
      width: "85%",
    },
    {
      label: "Eligible",
      event: "PAN_KYC_SUCCESS",
      color: "#83D1ED",
      width: "70%",
    },
    {
      label: "Approved",
      event: "AADHAAR_KYC_SUCCESS",
      color: "#B897E1",
      width: "55%",
    },
    {
      label: "Disbursed",
      event: "DOCUMENTS_ADDED_SUCCESSFULLY",
      color: "#96B860",
      width: "40%",
    },
  ];

const funnelData = useMemo(() => {
  if (!data) return [];

  return funnelConfig.map((item) => {
    let value = 0;
    let percentage = 0;

    if (item.event === "AADHAAR_KYC_SUCCESS") {
      value = data?.leadInfo?.approvedLeads ?? 0;
      percentage = data?.leadInfo?.approvedConversionRate ?? 0;
    } else if (item.event === "DOCUMENTS_ADDED_SUCCESSFULLY") {
      value = data?.leadInfo?.disbursedLeads ?? 0;
      percentage = data?.leadInfo?.disbursedConversionRate ?? 0;
    } else {
      const match = data?.events?.find((d) => d.event === item.event);
      value = match?.count ?? 0;
      percentage = match?.percentage ?? 0;
    }

    return {
      label: item.label,
      value,
      percentage,
      width: item.width, 
      color: item.color,
    };
  });
}, [data]);
  return (
    <>
      <div className="funnel-card">
        <h2 className="common-heading">Funnel Overview</h2>
        {funnelData?.map((Val, id) => {
          return (
            <div className="custom-funnel">
              <div style={{ width: "100%" }}>
                <div
                  className="blocks"
                  style={{ width: Val?.width, background: Val?.color }}
                >
                  {Val?.label}
                </div>
              </div>
              <div className="liess">
                <div className="line-funel" style={{ background: Val?.color }}>
                  <div
                    className="circless"
                    style={{ background: Val?.color }}
                  ></div>
                </div>
              </div>
              <div>
                <h5>{Val?.value ?? ""}</h5>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
